import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class SlackSubscriptionMembershipModel extends ModeModelBase {
  override _name = 'slackSubscriptionMembership';
  channelName: string;
  channel_type: any;
  override initialize(resource) {
    if (resource.channel_type === 'public') {
      this.channelName = '#' + resource.channel;
    } else if (resource.channel) {
      // private channel known to user
      this.channelName = resource.channel;
    } else {
      // hide private channel from user
      this.channelName = '';
    }
  }
  getDisplayName() {
    if (this.channelName.length === 0) {
      switch (this.channel_type) {
        case 'direct_message':
          return 'Sent to Direct Message';
        case 'private':
        default:
          return 'Sent to Private Channel';
      }
    } else {
      return this.channelName;
    }
  }
  override idAttribute = 'id';
  override belongsTo = 'reportSubscription';
  override parentIdAttribute = 'id';
  override attributes = [
    { name: 'channel', default: '' },
    { name: 'channel_id', default: '' },
    { name: 'channel_type', default: '' },
  ];
}

@Injectable({ providedIn: 'root' })
export class SlackSubscriptionMembershipModelAccessor extends ModelAccessorBase<SlackSubscriptionMembershipModel> {
  override name = 'slackSubscriptionMembership';
  override idAttribute = 'id';
  override parentModel = 'reportSubscription';
  override parentIdAttribute = 'id';
  override createAttributes = ['reportSubscription'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.slackSubscriptionMembership');
  }

  createModel(resource, opts?) {
    const model = new SlackSubscriptionMembershipModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
